import { Badge } from "../../../components/ui/badge";
import { cn } from "../../../lib/utils";
import { LastStage } from "../types";

const LABELS: Record<LastStage, string> = {
  arquivos_prontos: "Arquivos prontos",
  enviada_wts: "Enviada (WTS)",
  aceite: "Aceite",
  liquidado: "Liquidado",
  comprado: "Comprado",
  baixado: "Baixado",
  nao_enviada: "Não enviada",
};

const CLASSES: Record<LastStage, string> = {
  arquivos_prontos: "bg-slate-100 text-slate-700",
  enviada_wts: "bg-blue-100 text-blue-700",
  aceite: "bg-indigo-100 text-indigo-700",
  liquidado: "bg-amber-100 text-amber-700",
  comprado: "bg-violet-100 text-violet-700",
  baixado: "bg-emerald-100 text-emerald-700",
  nao_enviada: "bg-red-100 text-red-700",
};

export function LastStageBadge({ stage }: { stage: LastStage }) {
  return (
    <Badge variant="outline" className={cn("border-transparent", CLASSES[stage])}>
      {LABELS[stage]}
    </Badge>
  );
}
